var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mobile-nav-menu" }, [
    _c(
      "div",
      {
        staticClass: "mobile-nav-menu-header",
        class: { opened: _vm.isExpanded },
      },
      [
        _c(
          "div",
          {
            staticClass: "mobile-nav-menu-header__avatar",
            style: _vm.avatarStyle,
          },
          [
            _vm.group.is_buddy_group
              ? _c("div", {
                  staticClass: "mobile-nav-menu-header__group-mark buddy-group",
                })
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-nav-menu-header__name" }, [
          _vm._v(_vm._s(_vm.visibleName)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mobile-nav-menu-header__toggle-button",
            class: {
              "mobile-nav-menu-header__toggle-button_pushed": _vm.isExpanded,
            },
            on: {
              click: function ($event) {
                _vm.isExpanded = !_vm.isExpanded
              },
            },
          },
          [_c("i", { staticClass: "fa fa-bars" })]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isExpanded,
            expression: "isExpanded",
          },
        ],
        staticClass: "mobile-nav-menu-dropdown",
      },
      _vm._l(_vm.actions, function (icon) {
        return _c(
          "div",
          {
            key: icon.label,
            staticClass: "mobile-nav-menu-item",
            attrs: { tabindex: "0" },
            on: {
              click: function ($event) {
                return _vm.onActionClick(icon)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onActionClick(icon)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "mobile-nav-menu-item__icon",
                class: icon.iconType === "fa" ? undefined : icon.iconClass,
              },
              [
                icon.iconType === "fa"
                  ? _c("i", { staticClass: "fas", class: icon.iconClass })
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-nav-menu-item__label" }, [
              _vm._v(_vm._s(icon.label) + "\n                "),
              icon.counter !== undefined
                ? _c("span", { staticClass: "mobile-nav-menu-item__badge" }, [
                    _vm._v(_vm._s(icon.counter)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              icon.hasNew
                ? _c(
                    "span",
                    {
                      staticClass:
                        "mobile-nav-menu-item__badge mobile-nav-menu-item__badge_new",
                    },
                    [_vm._v("NEW")]
                  )
                : _vm._e(),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }